/* globals cision, moment */

$(function () {
	'use strict';

	var settings = cision.websolution.settings.general;
	var showVolume = false;
	var endOfDayStartFrom = moment().subtract(1, 'years').format('YYYY-MM-DD');
	var endOfDayEndTime = moment().format('YYYY-MM-DD');
	var today = moment().format('YYYY-MM-DD');
	var texts = cision.websolution.texts[settings.uiLanguage];
	var typeOfChart = 'endOfDay';
	var actions;
	var compareType;
	var firstTypeChange = true;
	var activeChangeOfType; // boolean
	var loadingTimeoutId;

	var wrapper = $('.sharegraph-wrapper');
	var graphContainer;

	var graphContainerSelector = settings.chartContainerId;
	var templateSelector = '#templatesharegraph';
	var renderTargetSelector = '#cision-websolution-container';

	$.support.cors = true;

	if (wrapper.length) {
		init();
	}

	function renderSharegraph (model) {
		var renderedHtml = $(templateSelector).render(model);
		$(renderTargetSelector).html(renderedHtml);
	}

	function init () {
		actions = actionsObject();

		cision.websolution.tickers.render();
		cision.websolution.trades.render();
		cision.websolution.performance.render();
		cision.websolution.orderbook.render();
		renderSharegraph($.extend({}, texts, cision.websolution.settings));

		graphContainer = $('#' + graphContainerSelector);

		showEndOfDay();

		initEvents();
		initDatePicker();
		initPrintEvent();

		wrapper.find('#share-download').netrCustomSelect();
		wrapper.removeClass('is-loading');
	}

	function initPrintEvent () {
		// fix for graph size issue on print
		var width = graphContainer.width();
		var height = graphContainer.height();
		var beforePrint = function () {
			graphContainer.highcharts().setSize(width, height, false);
		};
		var afterPrint = function () {
			graphContainer.highcharts().setSize.apply(this, this.resetParams);
		};

		if (window.matchMedia) {
			var mediaQueryList = window.matchMedia('print');
			mediaQueryList.addListener(function (mql) {
				if (mql.matches) {
					beforePrint();
				}
				else {
					afterPrint();
				}
			});
		}

		// making sure the above fix works in Firefox
		window.onbeforeprint = beforePrint;
		window.onafterprint = afterPrint;
	}

	function initEvents () {
		wrapper.find('.show-hide-instrument').on('change', function () {
			if ($(this).is(':disabled')) {
				return false;
			}
			updateInstrumentSeries($(this));
			updateCompareType();
		});

		wrapper.find('.share-info').on('click', 'input[type="radio"]', function () {
			activeChangeOfType = true;
		});

		wrapper.find('.share-info').on('change', 'input[type="radio"], input[type="checkbox"]', function (event) {
			var arg = $(this).data('arg');
			var delegate = actions[arg];

			if (delegate) {
				delegate(event, $(this));
			}
		});

		wrapper.find('#share-options-select .show-hide-instrument').on('click', function () {
			if ($(this).hasClass('disabled')) {
				return false;
			}

			$(this).toggleClass('selected');
			updateInstrumentSeries($(this));
			updateCompareType();
		});

		wrapper.find('.share__period').on('click', '.c-button-group__item', function (event) {
			// We do nothing if there is no instance of highcharts.
			if (graphContainer.highcharts() === undefined) {
				return;
			}

			$('.share__period button').removeClass('c-button-group__item--active');
			$('.share__period-datepickers input').removeClass('share__period-datepickers--active');
			$(this).addClass('c-button-group__item--active');

			var arg = $(this).data('key');
			var delegate = actions[arg];

			if (delegate) {
				delegate(event, $(this));
			}
		});

		wrapper.find('.input-group-btn').on('click', function () {
			$(this).parent().find('input').datepicker('show');
		});

		wrapper.find('#share-download').on('change', function (event) {
			var select = event.target;
			var selectedOption = select.options[select.selectedIndex];
			var chartContainer = $('#' + settings.chartContainerId);

			switch (selectedOption.value) {
				case 'excel-download':
					window.location = selectedOption.dataset.url;
					break;

				case 'print-chart':
					chartContainer
						.highcharts()
						.print();
					break;

				case 'export-png-chart':
					chartContainer
						.highcharts()
						.exportChart(
							null,
							{ type: 'image/png'}
						);
					break;

				case 'export-jpeg-chart':
					chartContainer
						.highcharts()
						.exportChart({
							type: 'image/jpeg'
						});
					break;

				case 'export-svg-chart':
					chartContainer
						.highcharts()
						.exportChart({
							type: 'image/svg+xml'
						});
					break;

				case 'export-pdf-chart':
					chartContainer
						.highcharts()
						.exportChart({
							type: 'application/pdf',
							filename: 'my-pdf'
						});
					break;
			}

			// We reset the <select> to always behave like a dropdown.
			event.target.selectedIndex = 0;

			event.preventDefault();
		});
	}

	function initDatePicker () {
		var inputFrom = wrapper.find('#datePickerFrom input');
		var inputTo = wrapper.find('#datePickerTo input');

		inputFrom.datepicker(netr.string.translate('datepicker'));
		inputFrom.datepicker('option', {
			dateFormat: 'dd-mm-yy',
			maxDate: 0,
			gotoCurrent: false,
			defaultDate: 0
		});

		inputTo.datepicker(netr.string.translate('datepicker'));
		inputTo.datepicker('option', {
			dateFormat: 'dd-mm-yy',
			maxDate: 0,
			minDate: moment(endOfDayStartFrom).add(1, 'days').format('DD-MM-YYYY'),
			gotoCurrent: false,
			defaultDate: 0
		});

		inputFrom.datepicker('option', 'onSelect', function (date) {
			endOfDayStartFrom = moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');
			showEndOfDay();
			wrapper.find('.share__period button').removeClass('c-button-group__item--active');
			wrapper.find('.share__period-datepickers input').addClass('share__period-datepickers--active');
		});

		inputTo.datepicker('option', 'onSelect', function (date) {
			endOfDayEndTime = moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');
			showEndOfDay();
			wrapper.find('.share__period button').removeClass('c-button-group__item--active');
			wrapper.find('.share__period-datepickers input').addClass('share__period-datepickers--active');
		});

		// the datepicker arrow points in the wrong direction,
		// might be fixed in a future update of this plugin but for now this is necessary
		$(document).on('show', $('.datepicker').datepicker(), function () {
			wrapper.find('.datepicker')
				.removeClass('datepicker-orient-bottom')
				.addClass('datepicker-orient-top');
		});

		updateDateFields({ from: endOfDayStartFrom, to: today});
	}

	function actionsObject () {
		return {
			'partofday': showPartOfDay,
			'endofday': showEndOfDay,
			'percent': showComparisonChart,
			'price': showPriceChart,

			'volume': function (evt, obj) {
				showVolume = $(obj).is(':checked');

				if (typeOfChart === 'endOfDay') {
					showEndOfDay();
				}
				else {
					showPartOfDay();
				}

				resetReportAndPress();
			},

			'dataPeriodDays1': function () {
				endOfDayStartFrom = moment().subtract(1, 'days').format('YYYY-MM-DD');
				endOfDayEndTime = today;
				showPartOfDay();
				resetReportAndPress();
			},

			'dataPeriodWeeks1': function () {
				endOfDayStartFrom = moment().subtract(1, 'weeks').format('YYYY-MM-DD');
				endOfDayEndTime = today;
				showEndOfDay();
				resetReportAndPress();
			},

			'dataPeriodMonths1': function () {
				endOfDayStartFrom = moment().subtract(1, 'months').format('YYYY-MM-DD');
				endOfDayEndTime = today;
				showEndOfDay();
				resetReportAndPress();
			},

			'dataPeriodMonths3': function () {
				endOfDayStartFrom = moment().subtract(3, 'months').format('YYYY-MM-DD');
				endOfDayEndTime = today;
				showEndOfDay();
				resetReportAndPress();
			},

			'dataPeriodMonths6': function () {
				endOfDayStartFrom = moment().subtract(6, 'months').format('YYYY-MM-DD');
				endOfDayEndTime = today;
				showEndOfDay();
				resetReportAndPress();
			},

			'dataPeriodYears1': function () {
				endOfDayStartFrom = moment().subtract(1, 'years').format('YYYY-MM-DD');
				endOfDayEndTime = today;
				showEndOfDay();
				resetReportAndPress();
			},

			'dataPeriodYears5': function () {
				endOfDayStartFrom = moment().subtract(5, 'years').format('YYYY-MM-DD');
				endOfDayEndTime = today;
				showEndOfDay();
				resetReportAndPress();
			},

			'dataPeriodYears10': function () {
				endOfDayStartFrom = moment().subtract(10, 'years').format('YYYY-MM-DD');
				endOfDayEndTime = today;
				showEndOfDay();
				resetReportAndPress();
			},

			'dataPeriodYearsAll': function () {
				endOfDayStartFrom = '1998-09-07';
				endOfDayEndTime = today;
				showEndOfDay();
				resetReportAndPress();
			}
		};
	}

	function updateDateFields (params) {
		if (!params.from || !params.to) {
			throw new Error('Missing parameter');
		}

		wrapper.find('#datePickerFrom input').datepicker('setDate', (moment(params.from).format('DD-MM-YYYY')));
		wrapper.find('#datePickerTo input').datepicker('setDate', (moment(params.to).format('DD-MM-YYYY')));
	}

	/**
	 * NOTE: Sharegraph is losing the reports and press when changing period or
	 * toggle volume. The checkboxes will still be checked and that isn't good.
	 * The fix for this at the moment is to uncheck the checkboxes to have them
	 * in sync.
	 *
	 * TODO: Remove this function when Cision have fixed this issue. This fix
	 * was created 6 October 2018.
	 */
	function resetReportAndPress () {
		wrapper.find('#press-releases, #reports').attr('checked', false);
	}

	// Removes the highcharts instance.
	function destroyChart () {
		try {
			graphContainer.highcharts().destroy();
		}
		catch (e) {
		}
	}

	/**
	 * Show loading indicator over the chart.
	 * @param state {Boolean}
	 */
	function showLoading(state) {
		if (state) {
			if (loadingTimeoutId) {
				return;
			}

			loadingTimeoutId = setTimeout(function () {

				graphContainer.parent().addClass('is-loading');
			}, 100);
		}
		else {
			clearTimeout(loadingTimeoutId);
			loadingTimeoutId = undefined;
			graphContainer.parent().removeClass('is-loading');
		}

	}

	/**
	 * Disables all form controls in the share component.
	 * Controls with data-always-disabled will not be changed.
	 * @param state {Boolean}
	 */
	function disableFormControls (state) {
		var el = $('.share__period, .share-info')
			.find('input, button')
			.not('[data-always-disabled="true"]');

		if (state === true) {
			el.attr('disabled', true)
				.filter('input')
				.parent()
				.addClass('disabled');
		}
		else {
			el.attr('disabled', false)
				.filter('input')
				.parent()
				.removeClass('disabled');
		}
	}

	function showEndOfDay () {
		destroyChart();
		disableFormControls(true);
		showLoading(true);

		typeOfChart = 'endOfDay';

		var promise = cision.websolution.sharegraph.render({
			volumeOffset: -35,
			showVolume: showVolume,
			typeOfChart: 'EndOfDay',
			dateToStartFrom: endOfDayStartFrom /* '2012-01-01' */,
			dateToEnd: endOfDayEndTime,
			success: reinitializeState,
			chartComparison: compareType
		});

		$.when(promise).done(afterRender);
	}

	function showPartOfDay () {
		destroyChart();
		disableFormControls(true);
		showLoading(true);

		typeOfChart = 'partOfDay';

		var dow = parseInt(moment().format('d'));
		var daysBack = 1;

		if (dow > 5) {
			daysBack = 3;
		}

		var daysFrom = moment().subtract(daysBack, 'days').format('YYYY-MM-DD');

		var promise = cision.websolution.sharegraph.render({
			dateToStartFrom: daysFrom,
			dateToEnd: null,
			typeOfChart: 'PartOfDay',
			showVolume: showVolume,
			success: reinitializeState,
			chartComparison: compareType
		});

		$.when(promise).done(afterRender);
	}

	function afterRender () {
		updateDateFields({ from: endOfDayStartFrom, to: endOfDayEndTime });

		// fix for graph size issue on print
		var width = graphContainer.width();
		var height = graphContainer.height();

		var beforePrint = function () {
			graphContainer.highcharts().setSize(width, height, false);
		};

		var afterPrint = function () {
			graphContainer.highcharts().setSize.apply(this, this.resetParams);
		};

		if (window.matchMedia) {
			var mediaQueryList = window.matchMedia('print');

			mediaQueryList.addListener(function (mql) {
				if (mql.matches) {
					beforePrint();
				}
				else {
					afterPrint();
				}
			});
		}

		// making sure the above fix works in Firefox
		window.onbeforeprint = beforePrint;
		window.onafterprint = afterPrint;
	}

	function reinitializeState () {
		disableFormControls(false);

		wrapper.find('.show-hide-instrument')
			.each(function () {
				var thisElement = $(this);
				updateInstrumentSeries(thisElement);
				updateCompareType();
			});

		showLoading(false);
	}

	function updateCompareType () {
		if (firstTypeChange === true) {
			firstTypeChange = false;
			return;
		}

		var objChart = graphContainer.highcharts();
		var $elements = wrapper.find('.show-hide-instrument');

		var selectedIndexes = $elements.filter(function () {
			return !!this.dataset.triggercomparison && this.checked;
		});


		if (selectedIndexes.length) {
			if (!activeChangeOfType) {
				compareType = 'percent';
			}

			if (compareType === 'percent') {
				comparePercent(objChart);
			}
			else {
				comparePrice(objChart);
			}
		}
		else {
			if (!activeChangeOfType) {
				compareType = 'price';
			}

			if (compareType === 'price') {
				comparePrice(objChart);
			}
			else {
				comparePercent(objChart);
			}
		}
	}

	function comparePercent (objChart) {
		// Set Comparison since we have more instruments visible
		objChart.yAxis[0].setCompare('percent');
		document.getElementById('comp-type-percent').checked = true;
		// updateTypeControls(selector);
		objChart.yAxis[0].setExtremes(null);
	}

	function comparePrice (objChart) {
		objChart.yAxis[0].setCompare('price');

		document.getElementById('comp-type-value').checked = true;
		// updateTypeControls('value', false);

		// if the index is clicked to hide it highcharts needs a little time to set the new min value of the y-axis
		setTimeout(function () {
			if (!objChart || !objChart.yAxis) {
				return;
			}

			var ex = objChart.yAxis[0].getExtremes();
			var minValue = ex.min <= 0 ? 0 : ex.min;
			if (minValue >= 0) {
				// set the min and return the values
				objChart.yAxis[0].setExtremes(minValue, null, true, false);
			}
			else {
				objChart.yAxis[0].setExtremes(null);
			}
		}, 600);
	}

	var triggerAutomaticComparison = 0;

	/* This will be incremented for every peer-or-index added (decremented when removed) */
	function updateInstrumentSeries (element) {
		var objChart = graphContainer.highcharts();
		var uniqueKey = $(element).data('key');
		var makeVisible = element[0].checked || false;

		$.each(objChart.series,
			function (idx, objSerie) {

				var objCurrentInstrument = objSerie.userOptions.objOriginal;

				if (objCurrentInstrument && objCurrentInstrument.UniqueKey === uniqueKey) {
					objSerie.setVisible(makeVisible);
				}
			});

		if (uniqueKey === 'INSIDERS' && makeVisible) {
			addInsiders();
		}

		if (uniqueKey === 'DIVIDEND' && makeVisible) {
			addDividends();
		}
	}

	function addInsiders () {
		var objChart = graphContainer.highcharts();

		var isFound = false;
		$.each(objChart.series,
			function (idx, objSerie) {

				var objCurrentInstrument = objSerie.userOptions.objOriginal;

				if (objCurrentInstrument && objCurrentInstrument.UniqueKey === settings.insidersUniqueKey) {
					isFound = true;
				}
			});

		if (!isFound) {
			cision.websolution.insiders.renderToGraph(objChart,
				{
					startDate: endOfDayStartFrom
				});
		}
	}

	function showComparisonChart () {
		var objChart = graphContainer.highcharts();
		var comparison = 'percent';
		compareType = 'percent';

		$.each(objChart.series,
			function (i, serie) {
				if (serie.type !== 'flag' && serie.type !== 'column') {
					serie.update({
						compare: comparison
					},
					false);
				}
			});

		objChart.redraw();
		objChart.yAxis[0].setExtremes(null);
	}

	function showPriceChart () {
		var objChart = graphContainer.highcharts();
		var comparison = 'none';
		compareType = 'price';

		$.each(objChart.series,
			function (i, serie) {
				if (serie.type !== 'flag' && serie.type !== 'column') {
					serie.update({
						compare: comparison
					},
					false);
				}
			});

		objChart.redraw();
		var ex = objChart.yAxis[0].getExtremes();
		if (ex.dataMin < 0 || ex.min < 0) {
			// set the min and return the values
			objChart.yAxis[0].setExtremes(0, null, true, false);
		}
	}

	function addDividends () {
		var objChart = $('#' + settings.chartContainerId).highcharts();

		// Check if insiders are already
		var isFound = false;
		$.each(objChart.series,
			function (idx, objSerie) {

				var objCurrentInstrument = objSerie.userOptions.objOriginal;

				if (objCurrentInstrument && objCurrentInstrument.UniqueKey === settings.dividendsUniqueKey) {
					isFound = true;
				}
			});

		if (!isFound) {
			// Add as new instrument
			cision.websolution.dividend.renderToGraph(objChart,
				{
					startDate: endOfDayStartFrom
				});
		}
	}
});
